module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+ZmFjZWJvb2s8L3RpdGxlPjxwYXRoIGQ9Ik0xMiAwYzYuNjExIDAgMTIgNS4zODkgMTIgMTIgMCA2LjYzOS01LjM4OSAxMi0xMiAxMi02LjYzOSAwLTEyLTUuMzYxLTEyLTEyQzAgNS4zODkgNS4zNjEgMCAxMiAwem0xIDEwLjAyOFY3Ljg2YzAtLjgzMy4xNjctMS4zNjEgMS4yMjItMS4zNjFoMS42NEwxNiAzLjY2N3MtLjgzMy0uMTY3LTIuMjc4LS4xNjdDMTAuNzc4IDMuNSA5LjUgNS4yNzggOS41IDcuMjc4VjEwaC0ydjNoMnY3LjVIMTNWMTNoMi44MDZMMTYgMTAuMDI4aC0zeiIgZmlsbD0iI0I2RDNFMSIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/facebook.svg
// module id = kTiu
// module chunks = 89